//libraries
import Vue from 'vue'
import axios from 'axios'

let resource = 'question-blocks'
let resource_name = 'bloque'
let resource_name_plural = 'bloques'

let state = {
  blocks: [],
  questions: [],
  lists: [],
}

state[resource] = []

//functions receive state
let getters = {

}

//functions receive context and params
let actions = {
  async listBlocks ({ commit }, params) {
    try {
      commit('setBlocks', [])
      let res = await Vue.request.get(`account/${params.account_id}/${resource}/all`, {params: params.params || {}})
      if(res.data.success) {
        commit('setBlocks', res.data.resource)
        if(params.callback)
          params.callback(res.data)
      } else {
        if(params.callback)
          params.callback({error: `Error obteniendo lista de ${resource_name_plural}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error obteniendo lista de ${resource_name_plural}.`})
      console.error(e)
    }
  },
  async all ({ commit }, params) {
    try {
      commit('setItems', [])

      const res = await Vue.request.get(`account/${params.account_id}/${resource}`, { params: params.params || {} })
      const { data = {} } = res
      const { callback = () => {} } = params
      const { success = false, resource: dataResource = [] } = data

      if (!success) throw new Error(`Error obteniendo ${resource_name_plural}.`)

      commit('setItems', dataResource)

      return callback(data)
    } catch (e) {
      const { callback = () => {} } = params
      const message = { error: `Ocurrió un error obteniendo ${resource_name_plural}.` }

      console.error(e)

      return callback(message)
    }
  },
  async get ({ commit }, params) {
    try {
      let res = await Vue.request.get(`account/${params.account_id}/${resource}/${params.question_block_id}`, {params: params.params || {}})
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error obteniendo ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error obteniendo ${resource_name}.`})
      console.error(e)
    }
  },
  async create ({ commit }, params) {
    try {
      let res = await Vue.request.post(`account/${params.account_id}/${resource}`, params)
      if(res.data.success && params.callback) {
        commit('pushQuestion', res.data)
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error creando ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error creando ${resource_name}.`})
      console.error(e)
    }
  },
  async update ({ commit }, params) {
    try {
      let res = await Vue.request.patch(`account/${params.account_id}/${resource}/${params.question_block_id}`, params)
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error actualizando ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error actualizando ${resource_name}.`})
      console.error(e)
    }
  },
  async destroy ({ commit }, params) {
    try {
      let res = await Vue.request.delete(`account/${params.account_id}/${resource}/${params.question_block_id}`, {data: params})
      if(res.data.success && params.callback) {
        commit('deleteQuestion', params)
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error eliminando ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error eliminando ${resource_name}.`})
      console.error(e)
    }
  },
  async questions ({ commit }, params) {
    try {
      let res = await Vue.request.get(`account/${params.account_id}/${resource}/${params.question_block_id}/questions`, {params: params.params || {}})
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error obteniendo preguntas de ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error obteniendo preguntas de ${resource_name}.`})
      console.error(e)
    }
  },
  async createQuestion ({ commit }, params) {
    try {
      let res = await Vue.request.post(`account/${params.account_id}/${resource}/${params.question_block_id}/questions`, params)
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error creando pregunta.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error creando pregunta.`})
      console.error(e)
    }
  },
  async updateQuestion ({ commit }, params) {
    try {
      let res = await Vue.request.patch(`account/${params.account_id}/${resource}/${params.question_block_id}/questions/${params.question_id}`, params)
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error actualizando pregunta.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error actualizando pregunta.`})
      console.error(e)
    }
  },
  async destroyQuestion ({ commit }, params) {
    try {
      let res = await Vue.request.delete(`account/${params.account_id}/${resource}/${params.question_block_id}/questions/${params.question_id}`, params)
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error eliminando pregunta.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error eliminando pregunta.`})
      console.error(e)
    }
  },
  async answers ({ commit }, params) {
    try {
      let res = await Vue.request.get(`account/${params.account_id}/${resource}/${params.question_block_id}/answers`, {params: params.params || {}})
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error obteniendo respuestas de ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error obteniendo respuestas de ${resource_name}.`})
      console.error(e)
    }
  },
  async createAnswer ({ commit }, params) {
    try {
      let res = await Vue.request.post(`account/${params.account_id}/${resource}/${params.question_block_id}/answers`, params)
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error creando respuesta.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error creando respuesta.`})
      console.error(e)
    }
  },
  async updateAnswer ({ commit }, params) {
    try {
      let res = await Vue.request.patch(`account/${params.account_id}/${resource}/${params.question_block_id}/answers/${params.answer_id}`, params)
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error actualizando respuesta.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error actualizando respuesta.`})
      console.error(e)
    }
  },
  async destroyAnswer ({ commit }, params) {
    try {
      let res = await Vue.request.delete(`account/${params.account_id}/${resource}/${params.question_block_id}/answers/${params.answer_id}`, params)
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error eliminando respuesta.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error eliminando respuesta.`})
      console.error(e)
    }
  },
  async actions ({ commit }, params) {
    try {
      let res = await Vue.request.get(`account/${params.account_id}/${resource}/${params.question_block_id}/action`, {params: params.params || {}})
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error obteniendo acciones de ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error obteniendo acciones de ${resource_name}.`})
      console.error(e)
    }
  },
  async createAction ({ commit }, params) {
    try {
      let res = await Vue.request.patch(`account/${params.account_id}/${resource}/${params.question_block_id}/action`, params)
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error creando acción.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error creando acción.`})
      console.error(e)
    }
  },
  async updateAction ({ commit }, params) {
    try {
      let res = await Vue.request.patch(`account/${params.account_id}/${resource}/${params.question_block_id}/action`, params)
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error actualizando acción.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error actualizando acción.`})
      console.error(e)
    }
  },
  async destroyAction ({ commit }, params) {
    try {
      let res = await Vue.request.delete(`account/${params.account_id}/${resource}/${params.question_block_id}/action`, params)
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error eliminando acción.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error eliminando acción.`})
      console.error(e)
    }
  },
  async unanswered ({ commit }, params) {
    try {
      let res = await Vue.request.get(`account/${params.account_id}/${resource}/${params.question_block_id}/unanswered`, {params: params.params || {}})
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error obteniendo sugerencias.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error obteniendo sugerencias.`})
      console.error(e)
    }
  },
  async destroyUnanswered ({ commit }, params) {
    try {
      let res = await Vue.request.delete(`account/${params.account_id}/unanswered/${params.unanswered_id}`, params)
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error eliminando sugerencia.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error eliminando sugerencia.`})
      console.error(e)
    }
  },
  async sync ({ commit }, params) {
    try {
      let res = await Vue.request.post(`sync/cache`, params)
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error actualizando entrenamiento.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error actualizando entrenamiento.`})
      console.error(e)
    }
  },
  async keywords ({ commit }, params) {
    try {
      let res = await Vue.request.get(`account/${params.account_id}/${resource}/${params.question_block_id}/keywords`, {params: params.params || {}})
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error obteniendo sugerencias.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error obteniendo sugerencias.`})
      console.error(e)
    }
  },
  async createKeyword ({ commit }, params) {
    try {
      let res = await Vue.request.post(`account/${params.account_id}/${resource}/${params.question_block_id}/keywords`, params)
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error creando keyword.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error creando keyword.`})
      console.error(e)
    }
  },
  async updateKeyword ({ commit }, params) {
    try {
      let res = await Vue.request.patch(`account/${params.account_id}/${resource}/${params.question_block_id}/keywords/${params.keyword_id}`, params)
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error actualizando keyword.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error actualizando keyword.`})
      console.error(e)
    }
  },
  async destroyKeyword ({ commit }, params) {
    try {
      let res = await Vue.request.delete(`account/${params.account_id}/${resource}/${params.question_block_id}/keywords/${params.keyword_id}`, params)
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error eliminando keyword.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error eliminando keyword.`})
      console.error(e)
    }
  },
  async load ({ commit }, params) {
    try {
      console.log(params)
      const res = await Vue.request.post(`account/${params.account_id}/${resource}/load`, params)
      const { data = {} } = res
      const { callback = () => {} } = params
      const { success = false } = data

      if (!success) throw new Error('Error subiendo archivo.')

      return callback(data)
    } catch (e) {
      const { callback = () => {} } = params
      const message = { error: 'Ocurrió un error subiendo archivo.' }

      console.error(e)

      return callback(message)
    }
  },
  async addFilter ({ commit }, params) {
    try {
      let res = await Vue.request.post(`account/${params.account_id}/${resource}/${params._id}/addFilters`, params)
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error agregando filtro.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error agregando filtro.`})
      console.error(e)
    }
  },
  async removeFilter ({ commit }, params) {
    try {
      let res = await Vue.request.delete(`account/${params.account_id}/${resource}/${params._id}/removeFilter/${params.filter_id}`, params)
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error eliminando filtro.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error eliminando filtro.`})
      console.error(e)
    }
  },
}

//functions receive state
let mutations = {
  setItems (state, items) {
    state.questions = items
  },
  appendAnswerToQB (state, data) {
    let qblock = state.questions.find(q => q.id == data.id)
    qblock.answers.splice(0, 0, data.answer)
  },
  removeAnswerFromQB (state, data) {
    let qblock = state.questions.find(q => q.id == data.id)
    qblock.answers.splice(data.index, 1)
  },
  setLists (state, data) {
    state.lists = data
  },
  pushList (state, list) {
    state.lists.splice(0, 0, list)
  },
  pushQuestion (state, data) {
    if (data.success) {
      data.resource.action = null
      state.questions.splice(0, 0, data.resource)
    }
  },
  deleteQuestion (state, data) {
    let index = state.questions.findIndex(q => q._id == data.question_block_id)
    if (index >= 0) {
      state.questions.splice(index, 1)
    }
  },
  setBlocks (state, data) {
    state.blocks = data
  },
}

export default {
  state,
  mutations,
  actions,
  getters
}
